import React from 'react'
import { Paper, Typography } from '@material-ui/core'
import styled from 'styled-components'

const IFrame = styled.div`
  position: relative;
  width: 100%;
  padding-bottom: 56.25%; 
  height: 0;
  iframe {
    position: absolute;
    top:0;
    left: 0;
    width: 100%;
    height: 100%;
  }
`

const VideoContainer = styled.div`
  width: 100%;
  margin: 0 auto;
  @media (min-width: 960px) {
    width: 50%;
  }
`

const VideoDetails = ({ videos }) => {
  if (!videos) return <div>Loading...</div>

  const videoSrc = `https://www.youtube.com/embed/${videos.id.videoId}`
  return (
    <VideoContainer>
      <React.Fragment>
        <IFrame>
          <iframe src={videoSrc} frameBorder='0' width='100%' height='100%' title='Video Player' />
        </IFrame>
        <Paper elevation={5} style={{padding: '15px'}}>
          <Typography variant='h6'>{videos.snippet.title} - {videos.snippet.channelTitle}</Typography>
          <Typography variant='subtitle1'>{videos.snippet.channelTitle}</Typography>
          <Typography variant='subtitle2'>{videos.snippet.description}</Typography>
        </Paper>
      </React.Fragment>
    </VideoContainer>
  )
}

export default VideoDetails
